(function () {
	angular
		.module('trackeye')
		.factory('OpenLayers', _OpenLayersFactory);

	_OpenLayersFactory.$inject = ['config', 'OLCoord', '$compile'];

	function _OpenLayersFactory(config, OLCoord, $compile) {

		function OpenLayers(container) {
			this.map = undefined;
			this.layers = [];
			this.features = [];
			this.overlays = [];
			this.listeners = [];

			this.containerId = "openlayers_map";
			this.containerClass = "openlayers-map";

			this._initialize(container);
		}

		/**
		 * Sets the center of the map
		 * @param {SutMessage} message
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.setCenter = function (message) {
			if (message.hasLonLat()) {
				var coord = new OLCoord(message.getCoord());
				this.map.getView().setCenter(coord.getCoord());
			}

			return this;
		};

		/**
		 * Sets the zoom level of the map
		 * @param {number} zoom - A positive number
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.setZoom = function (zoom) {
			this.map.getView().setZoom(zoom);
			return this;
		};

		/**
		 * Returns the zoom level
		 * @returns {number}
		 */
		OpenLayers.prototype.getZoom = function () {
			return this.map.getView().getZoom();
		};

		/**
		 * Shows all added features on map
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.showAllFeatures = function () {
			this.clearAllVectors();

			for (var i = 0; i < this.features.length; i++) {
				var layerName = this.features[i].getType() + "Layer";
				this.getLayerSource(layerName).addFeature(this.features[i].getFeature());
			}

			return this;
		};

		/**
		 * Move features to a given lon/lat
		 * @param {string[]|string} names - Name of feature
		 * @param {SutMessage} message
		 */
		OpenLayers.prototype.moveFeatures = function (names, message) {
			if (!message.hasLonLat()) {
				return this;
			}

			var features = this.features.filter(function (feature) {
				if (names.indexOf(feature.getName()) >= 0)
					return feature;
			});

			features.forEach((function (feature) {
				if (!feature.isVisible()) {
					this.showFeatures(names);
				}
				feature.setCoords(message);
			}).bind(this));

			return this;
		};

		/**
		 * Show added features on the map
		 * @param {string[]} names - Name of a feature
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.showFeatures = function (names) {
			this.clearAllVectors();

			var features = this.features.filter(function (feature) {
				if (names.indexOf(feature.getName()) >= 0)
					return feature;
			});

			for (var i = 0; i < features.length; i++) {
				var feature = features[i],
					layerName = feature.getType() + "Layer";

				this.getLayerSource(layerName)
					.addFeature(feature.getFeature());

				feature.show();
			}
			return this;
		};

		OpenLayers.prototype.hideAllCircles = function() {
			var features = this.features.filter(function (feature) {
					return feature.isCircle();
			});

			for (var i = 0; i < features.length; i++) {
				var feature = features[i],
					layerName = feature.getType() + "Layer";

				if (feature.isHidden())
					continue;

				try {
					this.getLayerSource(layerName)
						.removeFeature(feature.getFeature());
				} catch (err) {
					_log('Could not hide circle', feature);
				}

				feature.hide();
			}

			return this;
		};

		/**
		 * Hide added features from the map
		 * @param {string[]} names - Name of a feature
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.hideFeatures = function (names) {
			var features = this.features.filter(function (feature) {
				if (names.indexOf(feature.getName()) >= 0)
					return feature;
			});

			for (var i = 0; i < features.length; i++) {
				var feature = features[i],
					layerName = feature.getType() + "Layer";

				if (feature.isHidden())
					continue;

				try {
					this.getLayerSource(layerName)
						.removeFeature(feature.getFeature());
				} catch (err) {
					_log('Could not remove feature', feature);
					_log(err);
				}

				feature.hide();
			}
			return this;
		};

		/**
		 * Remove all features from all vectors
		 */
		OpenLayers.prototype.clearAllVectors = function () {
			this.layers.forEach(function (layer) {
				layer.source.clear();
			});
		};

		/**
		 * Add features to the OL instance
		 * @param {OLFeature[]} features
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.addFeatures = function (features) {
			for (var i = 0; i < features.length; i++) {
				this.features.push(features[i])
			}
			return this;
		};

		/**
		 * Returns a feature
		 * @param {string[]} names - Name of feature
		 * @returns {OLFeature[]}
		 */
		OpenLayers.prototype.getFeatures = function (names) {
			return this.features.filter(function (feature) {
				return (names.indexOf(feature.getName()) >= 0);
			});
		};

		/**
		 * Trigger the map to update its sizes, if the viewport has been changed.
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.updateSize = function () {
			this.map.updateSize();
			return this;
		};

		OpenLayers.prototype.addLayer = function (name, layer) {
			this.layers.push({
				name: name,
				layer: layer,
				source: layer.getSource()
			});

			this.map.addLayer(layer);
			return this;
		};

		/**
		 * Sets the view extent, to the features in the given layer.
		 * @param {string} name
		 * @param {number} [zoom_offset] - If set, the view will be zoomed out.
		 * @returns {OpenLayers}
		 */
		OpenLayers.prototype.setFocus = function (name, zoom_offset) {
			var layer_src = this.getLayerSource(name),
				extent = layer_src.getExtent();

			if (layer_src.getFeatures().length)
				this.map.getView().fit(extent, this.map.getSize());

			if (zoom_offset)
				this.setZoom(this.getZoom() - zoom_offset);

			return this;
		};

		/**
		 * Returns the layer object
		 * @param {string} layer_name
		 * @returns {ol.layer.Vector}
		 */
		OpenLayers.prototype.getLayer = function (layer_name) {
			var layer = this.layers.find(function (layer) {
				return layer.name === layer_name;
			});

			return layer.layer || undefined;
		};

		/**
		 * Returns the source for a given layer
		 * @param {string} layer_name
		 * @returns {ol.source.XYZ|ol.source.Image|*|ol.source.ImageCanvas|ol.source.Vector|ol.source.OSM}
		 */
		OpenLayers.prototype.getLayerSource = function (layer_name) {
			var layer = this.layers.find(function (layer) {
				return layer.name === layer_name;
			});

			return layer.source || undefined;
		};

		OpenLayers.prototype.addControlByElement = function (element_id) {
			var element = document.getElementById(element_id);

			if (!element)
				return;

			this.map.addControl(
				new ol.control.Control({
					element: element
				})
			);
		};

		OpenLayers.prototype.addOverlayByElement = function (name, element_id) {
			var element = document.getElementById(element_id);

			if (!element)
				return;

			var overlay = {
				name: name,
				src: new ol.Overlay({
					element: element,
					autoPan: true,
					autoPanAnimation: {
						duration: 250
					}
				})
			};

			this.overlays.push(overlay);
			this.map.addOverlay(overlay.src);
		};

		OpenLayers.prototype.setListener = function (event_name, cb) {
			this.listeners.push({
				event: event_name,
				cb: cb
			});
		};

		OpenLayers.prototype.fire = function (event_name, data) {
			var filtered = this.listeners.filter(function(listener) {
				return listener.event === event_name;
			});

			if (!filtered.length)
				return;

			filtered.forEach(function(listener) {
				if (typeof listener.cb === "function") {
					listener.cb(data);
				}
			});
		};

		/**
		 * Initialize the map.
		 * @private
		 */
		OpenLayers.prototype._initialize = function (container) {
			/**
			 * Make an element to act as a container for the map.
			 */
			var mapElement = document.createElement("div");
			mapElement.setAttribute('id', this.containerId);
			mapElement.setAttribute('class', this.containerClass);

			container.append(mapElement);

			this._setInitialMapSettings(mapElement);
			this._setupListeners();
			this._setupVectorsAndLayers();
		};

		/**
		 * Set the initial map settings, such as tiles, controls and view
		 * @private
		 */
		OpenLayers.prototype._setInitialMapSettings = function (mapElement) {
			/**
			 * @todo this should be in config
			 * Initial center on map
			 */
			var lon = 8.46869137,
				lat = 55.5135842,
				coord = new OLCoord([lon, lat]);
			/**
			 * Add tile layer, using tiles from given url
			 */
			var layer = new ol.layer.Tile({
				source: new ol.source.XYZ({
					url: config.openlayers.url,
					crossOrigin: null,
					tilePixelRatio: 2
				})
			});

			/**
			 * Set the initial view, for the map
			 * using the supplied lat, lon and projection.
			 */
			var view = new ol.View({
				center: coord.getCoord(),
				zoom: config.openlayers.zoom.initial,
				minZoom: config.openlayers.zoom.min,
				maxZoom: config.openlayers.zoom.max
			});

			/**
			 * Initilize the actual map
			 */
			this.map = new ol.Map({
				target: mapElement,
				layers: [layer],
				controls: [
					new ol.control.FullScreen(),
					new ol.control.ScaleLine(),
					new ol.control.Zoom()
				],
				view: view
			});
		};

		OpenLayers.prototype._setupListeners = function () {
			var self = this,
				_map = this.map,
				_features = this.features;

			_map.on('singleclick', function (evt) {
				var featuresAtPixel = [];

				_map.forEachFeatureAtPixel(evt.pixel, function (feature_src, layer) {
					if (feature_src.getGeometryName() === 'pointGeom') {
						var feature = _features.find(function (_feature) {
							return _feature.isMarker() && _feature.getId() === feature_src.getId();
						});

						if (feature)
							featuresAtPixel.push(feature);
					}
				});

				var popup = self.overlays.find(function(overlay) {
					return overlay.name === 'popup';
				});

				if (!featuresAtPixel.length) {
					self.fire('popup.close');
					popup.src.setPosition(undefined);
					return;
				}

				self.fire('popup.open',featuresAtPixel);
				popup.src.setPosition(featuresAtPixel[0].source.getGeometry().getCoordinates());
			});
		};

		/**
		 * Prepare the instance for features
		 * @private
		 */
		OpenLayers.prototype._setupVectorsAndLayers = function () {
			/**
			 * Create vector source, and add it to a named vector layer
			 * push the layer to the map.
			 */
			var layers = ["circleLayer", "markerLayer"];

			for (var i = 0; i < layers.length; i++) {
				this.addLayer(layers[i], new ol.layer.Vector({
					source: new ol.source.Vector(),
					zIndex: i+10
				}));
			}

			this._setupClusterLayer();
		};

		OpenLayers.prototype._setupClusterLayer = function () {

			var style_cache = {},
				clusters = new ol.layer.Vector({
					source: new ol.source.Cluster({
						distance: 20,
						source: this.getLayerSource('markerLayer')
					}),
					style: (function(feature, resolution) {
						var cluster_size 	= feature.get('features').length,
							cluster_style 	= style_cache[cluster_size];

						if (cluster_size > 1) {
							if (!cluster_style) {
								cluster_style = [new ol.style.Style({
									image: new ol.style.Circle({
										radius: 10,
										stroke: new ol.style.Stroke({
											color: '#FFF'
										}),
										fill: new ol.style.Fill({
											color: '#3399CC'
										})
									}),
									text: new ol.style.Text({
										text: cluster_size.toString(),
										fill: new ol.style.Fill({
											color: '#fff'
										})
									})
								})];
								style_cache[cluster_size] = cluster_style;
							}

							return cluster_style;
						} else {
							return undefined;
						}
					}).bind(this)
				});

			this.addLayer('clusterLayer', clusters);
		};


		/**
		 *
		 * @param {OLFeature|OLFeature[]} features
		 */
		OpenLayers.prototype.showAllFeaturesExcept = function (features) {
			this.clearAllVectors();

			for (var i = 0; i < this.features.length; i++) {
				var layerName = this.features[i].getType() + "Layer";
				this.getLayerSource(layerName).addFeature(this.features[i].getFeature());
			}

			return this;
		};

		/**
		 *
		 * @param {ol.Feature|ol.Feature[]} feature_src
		 * @returns {OLFeature[]}
		 */
		OpenLayers.prototype.getPointFeaturesBySource = function (feature_src) {

			if ( !(feature_src instanceof Array) )
				feature_src = [feature_src];

			return this.features.filter(function (feature) {
				if (feature.isMarker())
					return ( feature_src.indexOf(feature.getFeature()) >= 0 );

				return false;
			});
		};

		/**
		 *
		 * @param {ol.Feature|ol.Feature[]} feature_src
		 * @returns {OLFeature[]}
		 */
		OpenLayers.prototype.getCircleFeaturesBySource = function (feature_src) {

			if ( !(feature_src instanceof Array) )
				feature_src = [feature_src];

			return this.features.filter(function (feature) {
				if (feature.isCircle())
					return ( feature_src.indexOf(feature.getFeature()) >= 0 );

				return false;
			});
		};

		return OpenLayers;
	}
})();